export const mapPin = (
  <>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4167 5.86782C10.2812 5.84508 10.142 5.83325 10 5.83325C8.61929 5.83325 7.5 6.95254 7.5 8.33325C7.5 9.71396 8.61929 10.8333 10 10.8333C11.3807 10.8333 12.5 9.71396 12.5 8.33325C12.5 8.19129 12.4882 8.05209 12.4654 7.91659"
        stroke="#080808"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M4.16683 12.6802C3.62728 11.3019 3.3335 9.83453 3.3335 8.45283C3.3335 4.70498 6.31826 1.66675 10.0002 1.66675C13.6821 1.66675 16.6668 4.70498 16.6668 8.45283C16.6668 12.1713 14.5391 16.5104 11.2193 18.0621C10.4454 18.4238 9.55495 18.4238 8.78105 18.0621C7.72078 17.5665 6.78209 16.7866 5.99548 15.8334"
        stroke="#080808"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </>
);
export const cart = (
  <>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M2 3L2.26121 3.09184C3.5628 3.54945 4.2136 3.77826 4.58584 4.32298C4.95808 4.86771 4.95808 5.59126 4.95808 7.03836V9.76C4.95808 12.7016 5.02132 13.6723 5.88772 14.5862C6.75412 15.5 8.14857 15.5 10.9375 15.5H12M16.2404 15.5C17.8014 15.5 18.5819 15.5 19.1336 15.0504C19.6853 14.6008 19.8429 13.8364 20.158 12.3075L20.6578 9.88275C21.0049 8.14369 21.1784 7.27417 20.7345 6.69708C20.2906 6.12 18.7738 6.12 17.0888 6.12H11.0235M4.95808 6.12H7"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </>
);
export const compass = (
  <>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.02542 9.21017C5.56228 7.86802 5.8307 7.19695 6.29238 6.67048C6.41002 6.53633 6.53633 6.41002 6.67048 6.29238C7.19695 5.8307 7.86802 5.56228 9.21017 5.02542C15.5025 2.50848 18.6487 1.25001 20.4457 2.47117C20.8718 2.7607 21.2393 3.1282 21.5288 3.55428C22.4801 4.95418 21.9267 7.17279 20.4457 11.0596C20.0256 12.1623 19.5308 13.3992 18.9746 14.7898C18.4377 16.132 18.1693 16.8031 17.7076 17.3295C17.59 17.4637 17.4637 17.59 17.3295 17.7076C16.8031 18.1693 16.132 18.4377 14.7898 18.9746C8.49749 21.4915 5.35132 22.75 3.55428 21.5288C3.1282 21.2393 2.76071 20.8718 2.47117 20.4457C1.52476 19.053 2.06771 16.8499 3.53158 13"
        stroke="#080808"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M12.5 14.9585C12.3374 14.9858 12.1704 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 12.1704 14.9858 12.3374 14.9585 12.5"
        stroke="#080808"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </>
);
export const search = (
  <>
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3334 12.8335L14.6667 15.1668"
        stroke="#080808"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M4.50004 2.68078C5.43159 2.14191 6.51313 1.8335 7.66671 1.8335C11.1645 1.8335 14 4.66903 14 8.16683C14 11.6646 11.1645 14.5002 7.66671 14.5002C4.1689 14.5002 1.33337 11.6646 1.33337 8.16683C1.33337 7.01325 1.64179 5.93171 2.18066 5.00016"
        stroke="#080808"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </>
);
export const edit = (
  <>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_175_200)">
        <path
          d="M11.9668 3.39823L12.7392 2.62583C14.019 1.34608 16.0938 1.34608 17.3736 2.62583C18.6534 3.90558 18.6534 5.98047 17.3736 7.26023L16.6012 8.03263M11.9668 3.39823C11.9668 3.39823 12.0634 5.03958 13.5116 6.48783C14.9599 7.93608 16.6012 8.03263 16.6012 8.03263M11.9668 3.39823L10.0001 5.36495M16.6012 8.03263L12.2173 12.4165L9.63448 14.9993L9.50017 15.1337C9.0192 15.6146 8.77871 15.8551 8.51355 16.0619C8.20076 16.3059 7.86232 16.5151 7.50423 16.6857C7.20066 16.8304 6.87802 16.938 6.23273 17.153L3.49835 18.0645M3.49835 18.0645L2.82995 18.2873C2.5124 18.3932 2.1623 18.3105 1.92561 18.0738C1.68892 17.8371 1.60627 17.487 1.71212 17.1695L1.93492 16.5011M3.49835 18.0645L1.93492 16.5011M1.93492 16.5011L2.84638 13.7667C3.06148 13.1214 3.16903 12.7988 3.3137 12.4952C3.48436 12.1371 3.69353 11.7987 3.9375 11.4859C4.14432 11.2207 4.3848 10.9802 4.86577 10.4993L7.08341 8.28162"
          stroke="#008000"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_175_200">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </>
);
export const bin = (
  <>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.64209 3.33268C7.98529 2.36169 8.91132 1.66602 9.99983 1.66602C11.0884 1.66602 12.0144 2.36169 12.3576 3.33268"
        stroke="#F70D1A"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M17.0832 5H2.9165"
        stroke="#F70D1A"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M15.3113 12.8332C15.1638 15.0457 15.09 16.1519 14.3692 16.8263C13.6483 17.5007 12.5397 17.5007 10.3223 17.5007H9.67787C7.46054 17.5007 6.35187 17.5007 5.63103 16.8263C4.91019 16.1519 4.83644 15.0457 4.68895 12.8332L4.30566 7.08398M15.6946 7.08398L15.5279 9.58398"
        stroke="#F70D1A"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M7.91675 9.16602L8.33342 13.3327"
        stroke="#F70D1A"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M12.0834 9.16602L11.6667 13.3327"
        stroke="#F70D1A"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </>
);
export const letter = (
  <>
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.3333 16.0007C29.3333 21.029 29.3333 23.5431 27.7712 25.1052C26.2091 26.6673 23.6949 26.6673 18.6666 26.6673H13.3333C8.30498 26.6673 5.79082 26.6673 4.22872 25.1052C2.66663 23.5431 2.66663 21.029 2.66663 16.0007C2.66663 10.9723 2.66663 8.45818 4.22872 6.89608C5.79082 5.33398 8.30498 5.33398 13.3333 5.33398H18.6666C23.6949 5.33398 26.2091 5.33398 27.7712 6.89608C28.6421 7.76699 29.0275 8.93383 29.198 10.6673"
        stroke="#080808"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M24 10.666L21.1215 13.0648C18.6726 15.1055 17.4482 16.1258 16 16.1258C15.1343 16.1258 14.3485 15.7612 13.3333 15.0319M8 10.666L9.2 11.666L10.4 12.666"
        stroke="#080808"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </>
);
export const chat = (
  <>
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6666 14H21.3333"
        stroke="#080808"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M10.6666 18.666H18"
        stroke="#080808"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M22.6667 4.44978C20.7056 3.31531 18.4286 2.66602 16 2.66602C8.63625 2.66602 2.66671 8.63555 2.66671 15.9993C2.66671 18.1323 3.16753 20.1482 4.05799 21.936C4.29463 22.4111 4.37339 22.9541 4.2362 23.4668L3.44206 26.4349C3.09731 27.7233 4.27606 28.9021 5.56451 28.5573L8.53256 27.7632C9.04528 27.626 9.58832 27.7048 10.0634 27.9414C11.8512 28.8319 13.8671 29.3327 16 29.3327C23.3638 29.3327 29.3334 23.3631 29.3334 15.9993C29.3334 13.5708 28.6841 11.2938 27.5496 9.33268"
        stroke="#080808"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </>
);
export const chatLight = (
  <>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_376_3155)">
        <path d="M5.3335 7H10.6668" stroke="white" stroke-linecap="round" />
        <path
          d="M5.3335 9.33398H9.00016"
          stroke="white"
          stroke-linecap="round"
        />
        <path
          d="M11.3332 2.22587C10.3526 1.65863 9.21413 1.33398 7.99984 1.33398C4.31794 1.33398 1.33317 4.31875 1.33317 8.00065C1.33317 9.06711 1.58358 10.0751 2.02881 10.969C2.14713 11.2065 2.18651 11.478 2.11792 11.7344L1.72085 13.2184C1.54847 13.8626 2.13785 14.452 2.78207 14.2796L4.26609 13.8826C4.52246 13.814 4.79398 13.8534 5.03152 13.9717C5.92541 14.4169 6.93338 14.6673 7.99984 14.6673C11.6817 14.6673 14.6665 11.6825 14.6665 8.00065C14.6665 6.78636 14.3419 5.6479 13.7746 4.66732"
          stroke="white"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_376_3155">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </>
);
export const secure = (
  <>
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="16.5"
        cy="12.5"
        r="2.66667"
        stroke="#1C274C"
        stroke-width="1.5"
      />
      <path
        d="M21.8333 20.5C21.8333 21.9728 21.8333 23.1667 16.5 23.1667C11.1666 23.1667 11.1666 21.9728 11.1666 20.5C11.1666 19.0272 13.5544 17.8333 16.5 17.8333C19.4455 17.8333 21.8333 19.0272 21.8333 20.5Z"
        stroke="#1C274C"
        stroke-width="1.5"
      />
      <path
        d="M4.5 14.3889C4.5 10.1254 4.5 7.99371 5.00335 7.27655C5.50671 6.55939 7.5111 5.87328 11.5199 4.50106L12.2836 4.23963C14.3733 3.52432 15.4181 3.16667 16.5 3.16667C17.5819 3.16667 18.6267 3.52432 20.7164 4.23963L21.4801 4.50106C25.4889 5.87328 27.4933 6.55939 27.9966 7.27655C28.5 7.99371 28.5 10.1254 28.5 14.3889C28.5 15.0329 28.5 15.7312 28.5 16.4885C28.5 19.8284 27.3843 22.4046 25.8333 24.3722M4.75712 19.1667C5.90034 24.8979 10.6019 27.8505 13.6981 29.203C14.66 29.6232 15.141 29.8333 16.5 29.8333C17.859 29.8333 18.34 29.6232 19.3019 29.203C20.0728 28.8663 20.9431 28.4304 21.8333 27.8771"
        stroke="#1C274C"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </>
);
export const call = (
  <>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1.33398C9 1.33398 10.5556 1.47541 12.5355 3.4553C14.5154 5.4352 14.6569 6.99084 14.6569 6.99084"
        stroke="white"
        stroke-linecap="round"
      />
      <path
        d="M9.47119 3.69141C9.47119 3.69141 10.1312 3.87997 11.1211 4.86992C12.1111 5.85987 12.2996 6.51983 12.2996 6.51983"
        stroke="white"
        stroke-linecap="round"
      />
      <path
        d="M10.0672 10.0181L10.4297 10.3625L10.0672 10.0181ZM10.3708 9.69847L10.0083 9.35413L10.3708 9.69847ZM11.9819 9.47488L11.7325 9.90822H11.7325L11.9819 9.47488ZM13.2556 10.208L13.0062 10.6413L13.2556 10.208ZM13.6145 12.5056L13.977 12.85L13.6145 12.5056ZM12.6674 13.5027L12.3049 13.1583L12.6674 13.5027ZM11.7842 13.9754L11.8333 14.473L11.7842 13.9754ZM5.21027 10.9835L5.5728 10.6391L5.21027 10.9835ZM2.50123 4.61716C2.48643 4.34141 2.2509 4.12988 1.97515 4.14468C1.69941 4.15948 1.48787 4.39501 1.50267 4.67076L2.50123 4.61716ZM6.12716 5.87005L6.48969 6.21439L6.12716 5.87005ZM6.31837 5.66874L6.6809 6.01308L6.31837 5.66874ZM6.42286 3.7954L6.83112 3.50674L6.42286 3.7954ZM5.5822 2.60641L5.17394 2.89507L5.17394 2.89507L5.5822 2.60641ZM3.14513 2.06142C2.95496 2.26164 2.9631 2.57811 3.16332 2.76829C3.36354 2.95847 3.68001 2.95032 3.87019 2.7501L3.14513 2.06142ZM7.37544 8.70393L7.73797 8.35959V8.35959L7.37544 8.70393ZM7.1094 13.2082C7.34321 13.3551 7.65186 13.2847 7.79879 13.0509C7.94572 12.8171 7.87529 12.5085 7.64148 12.3615L7.1094 13.2082ZM10.0753 13.3723C9.80504 13.3157 9.54005 13.4889 9.48346 13.7592C9.42686 14.0295 9.60009 14.2945 9.87037 14.3511L10.0753 13.3723ZM10.4297 10.3625L10.7333 10.0428L10.0083 9.35413L9.70464 9.67379L10.4297 10.3625ZM11.7325 9.90822L13.0062 10.6413L13.505 9.77464L12.2313 9.04153L11.7325 9.90822ZM13.2519 12.1613L12.3049 13.1583L13.03 13.847L13.977 12.85L13.2519 12.1613ZM5.5728 10.6391C2.98871 7.91856 2.55526 5.6237 2.50123 4.61716L1.50267 4.67076C1.56884 5.90357 2.0923 8.42684 4.84774 11.3278L5.5728 10.6391ZM6.48969 6.21439L6.6809 6.01308L5.95584 5.3244L5.76463 5.52571L6.48969 6.21439ZM6.83112 3.50674L5.99046 2.31775L5.17394 2.89507L6.01459 4.08406L6.83112 3.50674ZM6.12716 5.87005C5.76463 5.52571 5.76417 5.52619 5.76371 5.52668C5.76355 5.52685 5.76308 5.52735 5.76277 5.52768C5.76213 5.52836 5.76149 5.52905 5.76083 5.52975C5.75952 5.53116 5.75816 5.53264 5.75676 5.53418C5.75397 5.53725 5.751 5.54058 5.74788 5.54417C5.74164 5.55134 5.73479 5.55954 5.72747 5.5688C5.71281 5.58732 5.69623 5.61008 5.67884 5.63726C5.64396 5.69176 5.60614 5.76354 5.57411 5.85356C5.50898 6.0366 5.47348 6.279 5.51783 6.58171C5.60497 7.17645 5.99468 7.97627 7.01291 9.04828L7.73797 8.35959C6.7862 7.35755 6.55177 6.74043 6.50727 6.43674C6.4858 6.29024 6.50761 6.21305 6.51624 6.18881C6.52109 6.17518 6.52426 6.17139 6.52116 6.17624C6.51965 6.1786 6.51666 6.183 6.51161 6.18938C6.50909 6.19257 6.50605 6.19625 6.50243 6.20042C6.50061 6.2025 6.49865 6.20471 6.49653 6.20704C6.49547 6.2082 6.49437 6.2094 6.49323 6.21062C6.49266 6.21124 6.49208 6.21186 6.49149 6.21249C6.4912 6.2128 6.49075 6.21328 6.4906 6.21343C6.49015 6.21391 6.48969 6.21439 6.12716 5.87005ZM7.01291 9.04828C8.02815 10.1171 8.7949 10.5373 9.37991 10.6323C9.68009 10.6811 9.92308 10.6422 10.1071 10.5696C10.197 10.5341 10.2682 10.4924 10.3216 10.4546C10.3482 10.4357 10.3704 10.4178 10.3883 10.402C10.3973 10.3942 10.4052 10.3869 10.4121 10.3802C10.4155 10.3769 10.4187 10.3738 10.4216 10.3708C10.4231 10.3693 10.4245 10.3679 10.4258 10.3665C10.4265 10.3658 10.4272 10.3651 10.4278 10.3644C10.4281 10.3641 10.4286 10.3636 10.4288 10.3635C10.4292 10.363 10.4297 10.3625 10.0672 10.0181C9.70464 9.67379 9.7051 9.67331 9.70555 9.67283C9.7057 9.67268 9.70616 9.6722 9.70646 9.67189C9.70705 9.67127 9.70764 9.67066 9.70823 9.67006C9.7094 9.66885 9.71054 9.66769 9.71165 9.66656C9.71388 9.66432 9.71601 9.66223 9.71802 9.66028C9.72206 9.65639 9.72567 9.65309 9.72886 9.65028C9.73524 9.64469 9.73999 9.64107 9.74305 9.6389C9.74929 9.63447 9.74866 9.63598 9.74016 9.63933C9.72728 9.64441 9.66671 9.66581 9.54021 9.64527C9.27185 9.60168 8.69274 9.36478 7.73797 8.35959L7.01291 9.04828ZM5.99046 2.31775C5.31473 1.36203 3.96259 1.20079 3.14513 2.06142L3.87019 2.7501C4.21875 2.38314 4.83237 2.41197 5.17394 2.89507L5.99046 2.31775ZM12.3049 13.1583C12.1189 13.3542 11.9243 13.4591 11.7351 13.4778L11.8333 14.473C12.3314 14.4238 12.7344 14.1582 13.03 13.847L12.3049 13.1583ZM6.6809 6.01308C7.32595 5.33397 7.37161 4.27119 6.83112 3.50674L6.01459 4.08406C6.29602 4.4821 6.25287 5.01169 5.95584 5.3244L6.6809 6.01308ZM13.0062 10.6413C13.5534 10.9563 13.6605 11.7312 13.2519 12.1613L13.977 12.85C14.847 11.934 14.5936 10.4012 13.505 9.77464L13.0062 10.6413ZM10.7333 10.0428C10.9903 9.77228 11.3907 9.71149 11.7325 9.90822L12.2313 9.04153C11.499 8.62002 10.5908 8.74085 10.0083 9.35413L10.7333 10.0428ZM7.64148 12.3615C6.98564 11.9494 6.28766 11.3917 5.5728 10.6391L4.84774 11.3278C5.61709 12.1378 6.37931 12.7494 7.1094 13.2082L7.64148 12.3615ZM11.7351 13.4778C11.3707 13.5138 10.7942 13.5228 10.0753 13.3723L9.87037 14.3511C10.7027 14.5253 11.3828 14.5174 11.8333 14.473L11.7351 13.4778Z"
        fill="white"
      />
    </svg>
  </>
);
export const dotBlue = (
  <>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill="#0909FF" />
    </svg>
  </>
);
export const mapPinBlue = (
  <>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4167 5.86855C10.2812 5.84582 10.142 5.83398 10 5.83398C8.61929 5.83398 7.5 6.95327 7.5 8.33398C7.5 9.7147 8.61929 10.834 10 10.834C11.3807 10.834 12.5 9.7147 12.5 8.33398C12.5 8.19202 12.4882 8.05282 12.4654 7.91732"
        stroke="#0909FF"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M4.16683 12.6794C3.62728 11.3012 3.3335 9.83379 3.3335 8.45209C3.3335 4.70425 6.31826 1.66602 10.0002 1.66602C13.6821 1.66602 16.6668 4.70425 16.6668 8.45209C16.6668 12.1706 14.5391 16.5097 11.2193 18.0614C10.4454 18.4231 9.55495 18.4231 8.78105 18.0614C7.72078 17.5658 6.78209 16.7859 5.99548 15.8327"
        stroke="#0909FF"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </>
);
export const restart = (
  <>
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_501_1353)">
        <path
          d="M16.4404 9.60719C17.0344 11.8313 16.4589 14.3027 14.714 16.0476C12.6498 18.1118 9.56878 18.5394 7.08331 17.3304M15.3033 7.20876L14.714 6.61951C12.1105 4.01601 7.88944 4.01601 5.28595 6.61951C2.85801 9.04744 2.69429 12.8822 4.79478 15.4998M15.3033 7.20876H11.7678M15.3033 7.20876V3.67323"
          stroke="#727272"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_501_1353">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </>
);
export const arrowRight = (
  <>
    <svg
      width="6"
      height="10"
      viewBox="0 0 12 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.21139 0.299353L11.2861 8.48602C11.6746 8.81904 11.6746 9.42957 11.2861 9.76259L2.21139 17.9493C1.62861 18.4765 0.685059 18.088 0.685059 17.311L0.685059 0.937635C0.685059 0.160597 1.62861 -0.227924 2.21139 0.299353Z"
        fill="#8A8792"
      />
    </svg>
  </>
);
export const binBlue = (
  <>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.6666 4H2.33325" stroke="#0909FF" stroke-linecap="round" />
      <path
        d="M4.33337 4C4.37063 4 4.38925 4 4.40614 3.99957C4.9551 3.98566 5.43939 3.63661 5.62619 3.12021C5.63193 3.10433 5.63782 3.08666 5.6496 3.05132L5.71433 2.85714C5.76958 2.69139 5.79721 2.6085 5.83385 2.53813C5.98005 2.25738 6.25054 2.06242 6.56311 2.01251C6.64146 2 6.72882 2 6.90355 2H9.09653C9.27126 2 9.35862 2 9.43697 2.01251C9.74954 2.06242 10.02 2.25738 10.1662 2.53813C10.2029 2.6085 10.2305 2.69138 10.2858 2.85714L10.3505 3.05132C10.3622 3.08661 10.3682 3.10434 10.3739 3.12021C10.5607 3.63661 11.045 3.98566 11.5939 3.99957C11.6108 4 11.6295 4 11.6667 4"
        stroke="#0909FF"
      />
      <path
        d="M12.2489 10.2664C12.1309 12.0363 12.0719 12.9213 11.4953 13.4608C10.9186 14.0003 10.0317 14.0003 8.2578 14.0003H7.74223C5.96836 14.0003 5.08142 14.0003 4.50475 13.4608C3.92808 12.9213 3.86908 12.0363 3.75109 10.2664L3.44446 5.66699M12.5556 5.66699L12.4222 7.66699"
        stroke="#0909FF"
        stroke-linecap="round"
      />
    </svg>
  </>
);
export const eyeBlue = (
  <>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00004 2.97341C6.60772 2.78011 7.27366 2.66699 8.00004 2.66699C10.788 2.66699 12.6854 4.33336 13.8168 5.80321C14.3834 6.53934 14.6667 6.90741 14.6667 8.00033C14.6667 9.09324 14.3834 9.46131 13.8168 10.1974C12.6854 11.6673 10.788 13.3337 8.00004 13.3337C5.21212 13.3337 3.31468 11.6673 2.1833 10.1974C1.61668 9.46131 1.33337 9.09324 1.33337 8.00033C1.33337 6.90741 1.61668 6.53934 2.1833 5.80321C2.50412 5.38642 2.88653 4.95383 3.33337 4.54791"
        stroke="#0909FF"
        stroke-linecap="round"
      />
      <path
        d="M10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z"
        stroke="#0909FF"
      />
    </svg>
  </>
);
export const penBlue = (
  <>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_502_3541)">
        <path
          d="M9.57342 2.71878L10.1913 2.10086C11.2151 1.07706 12.8751 1.07706 13.8989 2.10086C14.9227 3.12466 14.9227 4.78457 13.8989 5.80838L13.2809 6.4263M9.57342 2.71878C9.57342 2.71878 9.65066 4.03186 10.8093 5.19046C11.9679 6.34906 13.2809 6.4263 13.2809 6.4263M9.57342 2.71878L8.00004 4.29216M13.2809 6.4263L9.77385 9.93338L7.70756 11.9997L7.60011 12.1071C7.21533 12.4919 7.02295 12.6843 6.81082 12.8497C6.56059 13.0449 6.28984 13.2122 6.00336 13.3488C5.7605 13.4645 5.50239 13.5506 4.98616 13.7226L2.79865 14.4518M2.79865 14.4518L2.26393 14.63C2.00989 14.7147 1.72981 14.6486 1.54046 14.4593C1.35111 14.2699 1.28499 13.9898 1.36967 13.7358L1.54791 13.2011M2.79865 14.4518L1.54791 13.2011M1.54791 13.2011L2.27708 11.0136C2.44916 10.4973 2.5352 10.2392 2.65094 9.99636C2.78746 9.70988 2.9548 9.43913 3.14997 9.1889C3.31543 8.97677 3.50782 8.78438 3.89259 8.39961L5.66671 6.62549"
          stroke="#0909FF"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_502_3541">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </>
);
export const addCategory = (
  <>
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 10.5L10 10.5M10 10.5L7.5 10.5M10 10.5L10 8M10 10.5L10 13"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M18.3333 10.4993C18.3333 14.4277 18.3333 16.3919 17.1129 17.6123C15.8926 18.8327 13.9284 18.8327 10 18.8327C6.07163 18.8327 4.10744 18.8327 2.88705 17.6123C1.66667 16.3919 1.66667 14.4277 1.66667 10.4993C1.66667 6.57098 1.66667 4.60679 2.88705 3.3864C4.10744 2.16602 6.07163 2.16602 10 2.16602C13.9284 2.16602 15.8926 2.16602 17.1129 3.3864C17.9244 4.19785 18.1963 5.33814 18.2874 7.16602"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </>
);
export const plus = (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M2.5 8.5H13.5"
        stroke="#6950BA"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 3V14"
        stroke="#6950BA"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </>
);
export const minus = (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M2.5 8.5H13.5"
        stroke="#6950BA"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </>
);
export const quoteIcon = (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.875 6.75V15C10.8738 16.1931 10.3993 17.337 9.55561 18.1806C8.71197 19.0243 7.56809 19.4988 6.375 19.5C6.17609 19.5 5.98532 19.421 5.84467 19.2803C5.70402 19.1397 5.625 18.9489 5.625 18.75C5.625 18.5511 5.70402 18.3603 5.84467 18.2197C5.98532 18.079 6.17609 18 6.375 18C7.17065 18 7.93371 17.6839 8.49632 17.1213C9.05893 16.5587 9.375 15.7956 9.375 15V14.25H3.75C3.35218 14.25 2.97064 14.092 2.68934 13.8107C2.40804 13.5294 2.25 13.1478 2.25 12.75V6.75C2.25 6.35218 2.40804 5.97064 2.68934 5.68934C2.97064 5.40804 3.35218 5.25 3.75 5.25H9.375C9.77282 5.25 10.1544 5.40804 10.4357 5.68934C10.717 5.97064 10.875 6.35218 10.875 6.75ZM20.25 5.25H14.625C14.2272 5.25 13.8456 5.40804 13.5643 5.68934C13.283 5.97064 13.125 6.35218 13.125 6.75V12.75C13.125 13.1478 13.283 13.5294 13.5643 13.8107C13.8456 14.092 14.2272 14.25 14.625 14.25H20.25V15C20.25 15.7956 19.9339 16.5587 19.3713 17.1213C18.8087 17.6839 18.0456 18 17.25 18C17.0511 18 16.8603 18.079 16.7197 18.2197C16.579 18.3603 16.5 18.5511 16.5 18.75C16.5 18.9489 16.579 19.1397 16.7197 19.2803C16.8603 19.421 17.0511 19.5 17.25 19.5C18.4431 19.4988 19.587 19.0243 20.4306 18.1806C21.2743 17.337 21.7488 16.1931 21.75 15V6.75C21.75 6.35218 21.592 5.97064 21.3107 5.68934C21.0294 5.40804 20.6478 5.25 20.25 5.25Z"
        fill="#E4E3E7"
      />
    </svg>
  </>
);
export const arrowUp = (
  <>
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.11 10.6887L9.49168 6.07039C8.94626 5.52497 8.05377 5.52497 7.50835 6.07039L2.89001 10.6887"
        stroke="#635D74"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </>
);
export const arrowDown = (
  <>
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.88998 6.31128L7.50832 10.9296C8.05373 11.475 8.94623 11.475 9.49165 10.9296L14.11 6.31128"
        stroke="#635D74"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </>
);
